<div
  class="innerBanner specialInterestBanner"
  [ngStyle]="{ backgroundImage: 'url(../../assets/images/home-banner-3.jpg)' }"
  style="min-height: 400px"
>
  <div class="bannerText">
    <h1>FAQ</h1>
  </div>
</div>
<div class="container contentPanel faqSpace">
  <div class="accordion" id="accordionExample">
    <div class="card" *ngFor="let faq of faqs; let i = index">
      <div class="card-header" [id]="'heading' + i">
        <h2 class="mb-0">
          <button
            class="btn btn-primary btn-block text-left"
            type="button"
            data-toggle="collapse"
            [attr.data-target]="'#collapse' + i"
            aria-expanded="true"
            [attr.aria-controls]="'collapse' + i"
          >
            {{ faq.question }}
          </button>
        </h2>
      </div>

      <div
        [id]="'collapse' + i"
        class="collapse"
        [class.show]="i === 0"
        [attr.aria-labelledby]="'heading' + i"
        data-parent="#accordionExample"
      >
        <div class="card-body">
          {{ faq.answer }}
        </div>
      </div>
    </div>
  </div>
</div>
